import type { SearchCapabilities } from '../../types/api';

/**
 * O que uma plataforma aceita pesquisar, em português (SPEC-014 §18).
 *
 * Lido das capabilities, nunca de plataforma codificada: quando uma busca é
 * ligada ou desligada por variável de ambiente, o texto muda sozinho. E nunca
 * nomeia fornecedor — a resposta das capabilities não o traz, de propósito
 * (SPEC-025 RF-Q02).
 */
export function describeAvailableSearches(capability: SearchCapabilities): string {
  const parts: string[] = [];

  if (capability.subjectSearch.supported) {
    parts.push(capability.subjectSearch.shape === 'exact_tag' ? 'assunto por hashtag' : 'assunto');
  }

  if (capability.personSearch.supported) {
    parts.push(capability.personSearch.requiresProfileUrl ? 'pessoa pelo link' : 'pessoa');
  }

  return parts.length === 0 ? 'indisponível' : parts.join(' e ');
}
